import { useState, useEffect } from 'react';
import axios from 'axios';

export async function invokeLambda(funcName, params) {
  const { data } = await axios.post(
    `https://h8jyjdq3y3.execute-api.us-west-2.amazonaws.com/${funcName}`,
    params,
  );

  /*if ('error' in data) {
    throw new Error(data.error)
  }*/

  return data;
}

export function useLambda(funcName, params, onLoad) {
  const [result, setResult] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [funcParams, setFuncParams] = useState(params);
  const load = !params && setFuncParams;

  useEffect(() => {
    if (!funcParams) {
      return;
    }

    let active = true;

    (async () => {
      try {
        setLoading(true);
        const { data } = await axios.post(
          `https://h8jyjdq3y3.execute-api.us-west-2.amazonaws.com/${funcName}`,
          funcParams,
          {
            withCredentials: false,
            crossDomain: true,
            crossdomain: true,
          },
        );

        if (!active) {
          return;
        }

        setLoading(false);
        if ('error' in data) {
          setError(data.error);
        } else {
          setResult(data);
        }
        if (onLoad) {
          if (onLoad.current) {
            onLoad.current(data);
          } else {
            onLoad(data);
          }
        }
      } catch (err) {
        setLoading(false);
        setError(err.message || err);
      }
    })();

    return () => {
      active = false;
    };
  }, [funcParams, onLoad]);

  return { result, error, loading, load };
}
